enum actionTypes {
  FETCH_THERMS = "FETCH_THERMS",
  FETCH_THERMS_TYPES = "FETCH_THERMS_TYPES",
}

export default actionTypes;
